module.exports = __webpack_public_path__ + "media/svg/user-bed57da8.svg";